import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { useNavigationHooks } from "..";
import { useViewActions } from "../../store";
import { INotification, UrlQueryParams } from "../../store/types";
import { JSON_to_URLEncoded } from "../../utils";
import { NotificationHandlerType } from "./use-click-handler";

export function useReplyHook(): NotificationHandlerType {
  const { push } = useHistory();
  const { commentsScrollAction } = useViewActions();
  const { getFormPathName } = useNavigationHooks();

  return useCallback(async ({ components }: INotification) => {
    if (!components.form_id) return;
    const searchObj: UrlQueryParams = {
      section: components.section_id,
      bar: "comments",
      comment: components.parent_id,
      reply: components.comment_id,
      "question-uuid": components.question_uuid || ""
    };
    push({
      pathname: getFormPathName(components.deal_id, components.form_id),
      search: JSON_to_URLEncoded(searchObj)
    });
    commentsScrollAction(true);
  }, []);
}
